export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-1200-7121f0d758f1cc8e9cead39d581e7323.png";